import makeStyles from '@mui/styles/makeStyles'

const getTop = ({ onMobile, modal, height }) => {
  if (modal) {
    return onMobile ? '8.75rem' : '50%'
  }

  return `${height}px`
}

const getTransform = ({ modal, onMobile }) => {
  if (modal) {
    return 'unset'
  }

  if (onMobile) {
    // Account for the mobile footer
    return 'translateY(calc(-50% - 64px))'
  }

  return 'translateY(-50%)'
}

const useStyles = makeStyles(theme => ({
  arrow: {
    zIndex: '0',
    position: 'absolute',
    top: getTop,
    margin: '0 3px',
    borderRadius: '50%',
    boxShadow: ({ modal, onMobile }) =>
      onMobile && modal ? 'none' : '0px 0px 5px -2px black',
    backgroundColor: 'white',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    fontSize: theme.size.xl,
    transform: getTransform,

    [theme.breakpoints.down(960)]: {
      boxShadow: 'none !important'
    }
  },

  leftArrow: {
    left: ({ onMobile }) => (onMobile ? '0' : '-1rem')
  },

  rightArrow: {
    right: ({ onMobile }) => (onMobile ? '0' : '-1rem')
  }
}))

export default useStyles
